export default "__VITE_ASSET__C$y1aVTf__"